export default __webpack_public_path__ + "static/media/produtos-venda.a008b4f4.png";